import Card from '@mui/material/Card';
import styled from '@mui/material/styles/styled';

export const M3CardBase = styled(Card)`
  transition: 50ms;
  border-radius: 12px;
  overflow: initial;

  &:not(.no-hover) {
    &.focused,
    &:hover {
      box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    }
  }

  &.dark-mode-card {
    background-color: var(--md-sys-color-background-dark);

    &:not(.no-hover) {
      &.focused,
      &:hover {
        box-shadow: 0px 2px 1px -1px rgba(255, 255, 255, 0.2),
          0px 1px 1px 0px rgba(255, 255, 255, 0.14),
          0px 1px 3px 0px rgba(255, 255, 255, 0.12);
      }
    }
  }
`;
